import { insertInfoCards } from "./components/info-cards";

document.addEventListener('DOMContentLoaded', function () {
  insertInfoCards();

  const endlessCollection = new Ajaxinate({
    container: '#product-grid',
    pagination: '.infinite_next',
    callback: function () {
      insertInfoCards();
    },
  });
});
